import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SocialMediaInfluencerRoutingModule } from './social-media-influencer-routing.module';

@NgModule({
	declarations: [],
	imports: [CommonModule, SocialMediaInfluencerRoutingModule]
})
export class SocialMediaInfluencerModule {}
